module.exports = __webpack_public_path__ + "static/media/researchmanager.452e5051.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/researchmanager.webp
// module id = 720
// module chunks = 0